import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { RoyalDecreeService } from "../../core/services/royal-decree.service";
import { TokenService } from "../../core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { ReformsService } from "src/app/maintenance-reforms/reforms.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TreeComponent } from "src/app/shared/tree/tree.component";
import { ModalFormComponent } from "src/app/shared/modal-form/modal-form.component";
import { TranslateService } from "@ngx-translate/core";
import { FormsConstants } from "src/app/constants/formsConstants";
import * as moment from "moment";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import {
  FieldsLinked,
  MoveUpDownFieldsLinked,
} from "../models/specificFields.model";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";

@Component({
  selector: "app-specific-fields-requested",
  templateUrl: "./specific-fields-requested.component.html",
  styleUrls: ["./specific-fields-requested.component.css"],
})
export class SpecificFieldsRequestedComponent implements OnInit {
  @ViewChild("tree") tree: TreeComponent;
  @ViewChild("modal") modal: ModalFormComponent;
  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  treeData = {
    "Reforma de importancia": null,
    "Otros certificados": null,
  };
  optionsTree = {
    readonly: false,
  };
  form: FormGroup;

  listFullInfoOfTree = {
    reforms: null,
    certificates: null,
  };

  titleModal: string;

  formModal;
  allFieldsChecked: boolean = false;
  routing = RoutingConstants.royalDecreeRouting;

  titleReformSelected: string = "";
  reformOrCertificiado: string = "";
  reformsLoaded = false;
  certificatesLoaded = false;
  idReformOrCert: string;

  linkBooleanForm;
  addFieldForm;

  fieldsAvailablesList: [];
  public fieldsLinkedList: FieldsLinked[];

  listBoolean = [];

  constructor(
    private toastrAlertService: ToastrAlertService,
    private royalDecreeService: RoyalDecreeService,
    private router: Router,
    public reformsService: ReformsService,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.getReforms();
    this.getOtherCertificates();
    this.getFieldsAvailable();
  }

  getReforms() {
    this.reformsLoaded = false;
    this.royalDecreeService.listImportantReform().subscribe(
      (data) => {
        this.buildReformsTree(data);
        this.listFullInfoOfTree.reforms = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getOtherCertificates() {
    this.certificatesLoaded = false;
    this.royalDecreeService.listAllOtherCertificates().subscribe(
      (data) => {
        this.buildCertificatesTree(data);
        this.listFullInfoOfTree.certificates = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getFieldsAvailable() {
    this.royalDecreeService.getListAvailableFields().subscribe(
      (data) => {
        this.fieldsAvailablesList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getListBooleanByReform(idCertificate: string) {
    this.royalDecreeService
      .listFieldsBooleansLinkedToReform(idCertificate)
      .subscribe(
        (data) => {
          this.listBoolean = data;
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  getListBooleanByCertificate(idCertificate: string) {
    this.royalDecreeService
      .listBooleanFieldsOfCertificate(idCertificate)
      .subscribe(
        (data) => {
          this.listBoolean = data;
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  buildReformsTree(data) {
    let node = new Object();
    let parents = data.filter((e) => e.padre == null);
    parents.forEach((element) => {
      let arrayChilds = [];
      let childs = data.filter((item) => item.padre == element.reId);
      if (childs && childs.length > 0) {
        childs.forEach((element) => {
          arrayChilds.push(element.reId + " - " + element.reDescr);
        });
      }
      node[element.reId + " - " + element.reDescr] =
        arrayChilds.length == 0 ? null : arrayChilds;
    });
    this.treeData["Reforma de importancia"] = node;
    this.reformsLoaded = true;
  }

  buildCertificatesTree(data) {
    let arrayChilds = [];
    data.forEach((element) => {
      arrayChilds.push(element.tcId + " - " + element.tcDescr);
    });
    this.treeData["Otros certificados"] = arrayChilds;
    this.certificatesLoaded = true;
  }

  itemSelected(value: any) {
    if (value && value.root && value.root.item && value.child) {
      this.titleReformSelected = value.root.item + " " + value.child;
      this.reformOrCertificiado = value.root.item;
      this.idReformOrCert = value.child.split("-")[0].trim();
      this.initForms();
      this.loadFieldAndBooleans();
    }
  }

  private loadFieldAndBooleans() {
    switch (this.reformOrCertificiado) {
      case "Reforma de importancia":
        this.getfieldsLinkedToReform(this.idReformOrCert);
        this.getListBooleanByReform(this.idReformOrCert);
        break;
      case "Otros certificados":
        this.getfieldsLinkedToCertificate(this.idReformOrCert);
        this.getListBooleanByCertificate(this.idReformOrCert);
        break;
    }
  }

  initForms() {
    this.linkBooleanForm = new FormGroup({
      boolean: new FormControl("empty", [Validators.required]),
      mandatory: new FormControl("S", Validators.required),
      fieldLinked: new FormControl("empty", [Validators.required]),
    });
    this.addFieldForm = new FormGroup({
      field: new FormControl("empty", [Validators.required]),
      mandatory: new FormControl("OPC", Validators.required),
    });
  }

  changeMandatory(e: any) {
    this.addFieldForm.value.mandatory = e.target.value;
  }

  changeMandatoryBoolean(e: any) {
    this.linkBooleanForm.value.mandatory = e.target.value;
  }

  onLink() {
    if (this.validateFieldsOnLink()) {
      this.royalDecreeService
        .linkBooleanToOtherField(
          this.linkBooleanForm.value.boolean,
          this.linkBooleanForm.value.fieldLinked,
          this.linkBooleanForm.value.mandatory
        )
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(data.mensaje);
            this.initForms();
            if (this.titleReformSelected.includes("Reforma de importancia")) {
              this.getfieldsLinkedToReform(this.idReformOrCert);
              this.getListBooleanByReform(this.idReformOrCert);
            } else {
              this.getfieldsLinkedToCertificate(this.idReformOrCert);
              this.getListBooleanByCertificate(this.idReformOrCert);
            }
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  validateFieldsOnLink(): boolean {
    let text: string = this.translateService.instant("messages.fieldsError");
    if (this.linkBooleanForm.value.boolean == "empty") {
      text = text + "El booleano (requerido)";
      this.toastrAlertService.toastrFail(text);
      return false;
    } else if (this.linkBooleanForm.value.fieldLinked == "empty") {
      text = text + "El campo asociado (requerido)";
      this.toastrAlertService.toastrFail(text);
      return false;
    } else {
      let posBoolean = this.fieldsLinkedList.findIndex(
        (e) => e.ccCampoid == this.linkBooleanForm.value.boolean
      );
      let posFieldLinked = this.fieldsLinkedList.findIndex(
        (e) => e.ccUniqueid == this.linkBooleanForm.value.fieldLinked
      );
      if (posBoolean < posFieldLinked) {
        return true;
      } else {
        let text: string = this.translateService.instant(
          "royalDecree.errorBooleanShouldBeBefore"
        );
        this.toastrAlertService.toastrFail(text);
        return false;
      }
    }
  }

  onAddField() {
    if (this.validateAddFieldLinked()) {
      let newPos;
      if (this.fieldsLinkedList.length > 0) {
        newPos =
          this.fieldsLinkedList[this.fieldsLinkedList.length - 1].ccPosicion +
          1;
      } else {
        newPos = 1;
      }

      let result = {
        ccCampoid: this.addFieldForm.value.field,
        ccCampovinculado: "",
        ccObligatorio: this.addFieldForm.value.mandatory == "OPC" ? 0 : 1,
        ccPosicion: newPos,
        ccUniqueid: this.idReformOrCert + "N" + newPos,
        ccValorvinculacion: "",
      };
      if (this.titleReformSelected.includes("Reforma de importancia")) {
        this.addReformFieldLinked(result);
      } else {
        this.addCertificatesFieldLinked(result);
      }
    }
  }

  validateAddFieldLinked(): boolean {
    if (this.addFieldForm.value.field == "empty") {
      let text: string = this.translateService.instant("messages.fieldsError");
      text = text + "El campo asociado (requerido)";
      this.toastrAlertService.toastrFail(text);
      return false;
    }

    return true;
  }

  getfieldsLinkedToReform(idReform: string) {
    this.royalDecreeService
      .listFieldsLinkedToReform(
        "?asc=true&order=ccUniqueid&page=0&size=10",
        idReform
      )
      .subscribe(
        (data) => {
          this.fieldsLinkedList = data.sort(this.orderByPosition);
          this.setFalseCheckbox();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getfieldsLinkedToCertificate(idCertificado: string) {
    this.royalDecreeService
      .listFieldsLinkedToCertificate(
        "?asc=true&order=ccUniqueid&page=0&size=10",
        idCertificado
      )
      .subscribe(
        (data) => {
          this.fieldsLinkedList = data;
          this.setFalseCheckbox();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  setFalseCheckbox() {
    this.fieldsLinkedList.forEach((element) => {
      element["checked"] = false;
    });
  }

  selectItem(item) {
    if (item == "all") {
      this.allFieldsChecked = this.allFieldsChecked ? false : true;
      if (this.allFieldsChecked) {
        this.fieldsLinkedList.filter((e) => {
          e.checked = true;
        });
      } else {
        this.fieldsLinkedList.filter((e) => {
          e.checked = false;
        });
      }
    } else {
      item.checked = item.checked ? false : true;
      const checkedAll = (e) => e.checked == false;
      if (this.fieldsLinkedList.some(checkedAll)) {
        this.allFieldsChecked = false;
      } else {
        this.allFieldsChecked = true;
      }
    }
  }

  removeCampoAsociado() {
    let arrayIds: string[] = [];
    this.fieldsLinkedList.filter((e) => {
      if (e.checked) {
        arrayIds.push(e.ccUniqueid.toString());
      }
    });
    this.royalDecreeService.removeField(arrayIds).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.initForms();
        if (this.titleReformSelected.includes("Reforma de importancia")) {
          this.getfieldsLinkedToReform(this.idReformOrCert);
          this.getListBooleanByReform(this.idReformOrCert);
        } else {
          this.getfieldsLinkedToCertificate(this.idReformOrCert);
          this.getListBooleanByCertificate(this.idReformOrCert);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  orderByPosition(a, b) {
    if (a.ccPosicion > b.ccPosicion) {
      return 1;
    }
    if (a.ccPosicion < b.ccPosicion) {
      return -1;
    }
    return 0;
  }

  addReformFieldLinked(result) {
    result.ccUniqueid = "RE" + result.ccUniqueid;
    this.royalDecreeService
      .addFieldForReform(result, this.idReformOrCert)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.initForms();
          this.getfieldsLinkedToReform(this.idReformOrCert);
          this.getListBooleanByReform(this.idReformOrCert);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  addCertificatesFieldLinked(result) {
    this.royalDecreeService
      .createFieldToCertificate(result, this.idReformOrCert)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.initForms();
          this.getfieldsLinkedToCertificate(this.idReformOrCert);
          this.getListBooleanByCertificate(this.idReformOrCert);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  action(value: any) {
    let form;
    switch (value.type) {
      case "createReform":
        form = FormsConstants.reformsForm;
        form[0].readonly = false;
        form[1].readonly = false;
        form = this.resetForm(form);
        this.titleModal = this.translateService.instant("reforms.titleCreate");
        this.modal.open(form, value);
        break;
      case "createOtherCertificate":
        form = FormsConstants.otherCertificateForm;
        form[0].readonly = false;
        form = this.resetForm(form);
        this.titleModal = this.translateService.instant(
          "reforms.createCertificate"
        );
        this.modal.open(form, value);
        break;
      case "createReformChild":
        this.titleModal = this.translateService.instant("reforms.titleCreate");
        this.setIdByDefault(value);
        break;
      case "removeReform":
        this.confirmSwal.fire().then((result) => {
          if (result.isConfirmed) {
            this.removeReform(value);
          }
        });
        break;
      case "removeOtherCertificate":
        this.confirmSwal.fire().then((result) => {
          if (result.isConfirmed) {
            this.removeCertificate(value);
          }
        });
        break;
      case "updateOtherCertificate":
        this.titleModal = this.translateService.instant(
          "reforms.updateCertificate"
        );
        form = this.setInfoCertificate(value);
        form[0].readonly = true;
        this.modal.open(form, value);
        break;
      case "updateReformChild":
        this.titleModal = this.translateService.instant("reforms.titleEdit");
        form = this.setInfoReform(value, FormsConstants.reformsChildForm);
        form[1].readonly = false;
        this.modal.open(form, value);
        break;
      case "updateReform":
        this.titleModal = this.translateService.instant("reforms.titleEdit");
        form = this.setInfoReform(value, FormsConstants.reformsForm);
        form[0].readonly = true;
        form[1].readonly = false;
        this.modal.open(form, value);
        break;
      default:
        break;
    }
  }

  resetForm(form) {
    form.forEach((e) => {
      if (e.type == "checkbox") {
        e.value = false;
      } else {
        e.value = "";
      }
    });

    return form;
  }

  setInfoCertificate(value) {
    let form = FormsConstants.otherCertificateForm;
    let itemSelected = this.listFullInfoOfTree.certificates.find(
      (e) => e.tcId == value.value.item.split(" - ")[0]
    );
    form.forEach((e) => {
      if (e.key == "tcId") {
        e.value = itemSelected.tcId;
      } else if (e.key == "tcDescr") {
        e.value = itemSelected.tcDescr;
      } else if (e.key == "tcTramitable") {
        e.value = itemSelected.tcExcluido == "N" ? true : false;
      }
    });
    return form;
  }

  removeCertificate(value) {
    this.royalDecreeService
      .removeOtherCertificate(value.value.item.split(" - ")[0])
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.getReforms();
          this.getOtherCertificates();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  removeReform(value) {
    this.royalDecreeService
      .removeReform(value.value.item.split(" - ")[0])
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.getReforms();
          this.getOtherCertificates();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  setIdByDefault(value) {
    this.royalDecreeService
      .generateReformCod(value.value.item.split(" - ")[0])
      .subscribe(
        (data) => {
          let form = FormsConstants.reformsChildForm;
          form[0].readonly = false;
          form[1].readonly = false;
          form = this.resetForm(form);
          form[0].value = data;
          this.modal.open(form, value);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  setInfoReform(value, form) {
    let itemSelected = this.listFullInfoOfTree.reforms.find(
      (e) => e.reId == value.value.item.split(" - ")[0]
    );
    form.forEach((e) => {
      if (e.key == "reId") {
        e.value = itemSelected.reId;
      } else if (e.key == "reDescr") {
        e.value = itemSelected.reDescr;
      } else if (e.key == "reTramitable") {
        e.value = itemSelected.reTramitable == 0 ? false : true;
      }
    });
    return form;
  }

  sendForm(value: any) {
    switch (value.type.type) {
      case "createReform":
        this.addReform(this.createReform(value, "parent"));
        break;
      case "createOtherCertificate":
        this.createCertificate(value);
        break;
      case "createReformChild":
        this.addReform(this.createReform(value, "child"));
        break;
      case "updateOtherCertificate":
        this.updateCertificate(value);
        break;
      case "updateReformChild":
        this.updateReform(this.createReform(value, "child"));
        break;
      case "updateReform":
        this.updateReform(this.createReform(value, "parent"));
        break;
      default:
        break;
    }
  }

  getInfoOfFormCertificate(value): any {
    let object = {
      tcDescr: value.form.find((e) => e.key == "tcDescr").value,
      tcExcluido: value.form.find((e) => e.key == "tcTramitable").value
        ? "N"
        : "S",
      tcId: value.form.find((e) => e.key == "tcId").value,
    };
    return object;
  }

  updateCertificate(value) {
    let object = this.getInfoOfFormCertificate(value);
    this.royalDecreeService.updateOtherCertificate(object).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.getReforms();
        this.getOtherCertificates();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  createCertificate(value) {
    let object = this.getInfoOfFormCertificate(value);
    this.royalDecreeService.addOtherCertificate(object).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.getReforms();
        this.getOtherCertificates();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  createReform(value, type: string) {
    let object = {
      padre: null,
      reActivarOcultos: 0,
      reAnulada: 0,
      reDescr: value.form.find((e) => e.key == "reDescr").value,
      reFhCreacion: moment(),
      reFhModificacion: null,
      reFormulario: "DUMMY",
      reId: value.form.find((e) => e.key == "reId").value,
      reMarcolegal: "N",
      reTramitable: value.form.find((e) => e.key == "reTramitable").value
        ? 1
        : 0,
    };
    if (type == "child") {
      object.padre = value.type.value.item.split(" - ")[0];
    }

    return object;
  }

  updateReform(object) {
    this.royalDecreeService.updateReform(object).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.getReforms();
        this.getOtherCertificates();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  addReform(object) {
    this.royalDecreeService.addReform(object).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.getReforms();
        this.getOtherCertificates();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
  public moveUp(field: FieldsLinked): void {
    let pos = this.getPositionField(field.ccUniqueid);

    if (this.fieldsLinkedList[pos - 1]) {
      let fieldAbove = this.fieldsLinkedList[pos - 1];
      let dtoToMove: MoveUpDownFieldsLinked = {
        uniqueIdMoveDown: fieldAbove.ccUniqueid,
        posicionMoveDown: field.ccPosicion,
        uniqueIdMoveUp: field.ccUniqueid,
        posicionMoveUp: fieldAbove.ccPosicion,
      };
      this.moveUpDown(dtoToMove);
    } else {
      this.toastrAlertService.toastrFail(
        "No se puede mover hacia arriba el primero"
      );
    }
  }

  public moveDown(field: FieldsLinked): void {
    let pos = this.getPositionField(field.ccUniqueid);
    if (this.fieldsLinkedList[pos + 1]) {
      let fieldDown = this.fieldsLinkedList[pos + 1];
      let dtoToMove: MoveUpDownFieldsLinked = {
        uniqueIdMoveDown: field.ccUniqueid,
        posicionMoveDown: fieldDown.ccPosicion,
        uniqueIdMoveUp: fieldDown.ccUniqueid,
        posicionMoveUp: field.ccPosicion,
      };
      this.moveUpDown(dtoToMove);
    } else {
      this.toastrAlertService.toastrFail(
        "No se puede mover hacia abajo el último"
      );
    }
  }

  private getPositionField(uniqueId: string): number {
    let pos = this.fieldsLinkedList.findIndex(
      (element) => element.ccUniqueid === uniqueId
    );
    return pos;
  }

  private moveUpDown(dtoToMove: MoveUpDownFieldsLinked) {
    this.sweetAlertService.sweetAlertLoading();
    this.royalDecreeService.moveUpOrDownLinkedField(dtoToMove).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.sweetAlertService.sweetAlertClose();
        this.loadFieldAndBooleans();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }
}
